import { render, staticRenderFns } from "./ToExchange.vue?vue&type=template&id=1f53d5d3&scoped=true&"
import script from "./ToExchange.vue?vue&type=script&lang=js&"
export * from "./ToExchange.vue?vue&type=script&lang=js&"
import style0 from "./ToExchange.vue?vue&type=style&index=0&id=1f53d5d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f53d5d3",
  null
  
)

export default component.exports